<style>

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-thumb {
  background: rgba(191, 188, 188, 0.6);
}

.required_err {
  color: rgba(255, 0, 0);
}

.elevation-1 tr:nth-of-type(even) {
    background-color: rgba(0, 0, 0, .03) !important;
}

.br {
    color: rgba(109, 103, 164);
}

</style>

<template>
<div>
    <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        sort-by="map_id"
        class="elevation-1"
        @dblclick:row="on_dbl_click">

    <template v-slot:top>
        <v-toolbar flat>
            <v-toolbar-title><h2 class="br">NAT Interfaces</h2></v-toolbar-title>
            <v-spacer></v-spacer>

            <v-dialog v-model="new_nat_map_dialog" max-width="500px">
                <det_nat_map_box v-model="show_det_nat_map_box"
                    @canceled="nat_map_box_on_cancel" 
                    @selected="nat_map_box_on_select($event)">
                </det_nat_map_box>
                <nat3_map_box v-model="show_snat_map_box"
                    @canceled="nat_map_box_on_cancel" 
                    @selected="nat_map_box_on_select($event)">
                </nat3_map_box>
                <nat11_map_box v-model="show_nat1to1_map_box"
                    @canceled="nat_map_box_on_cancel" 
                    @selected="nat_map_box_on_select($event)">
                </nat11_map_box>

                <ValidationObserver ref="new_nat_map_observer" v-slot="{ invalid }">
                    <v-card>
                        <v-card-title>
                            <span class="headline">Add a new NAT map</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container style="height: 520px; overflow-y: scroll;">
                                <v-row>
                                    <v-col cols="12">
                                        <ValidationProvider rules="required" v-slot="{ errors }">
                                            <v-text-field v-model="nat_map_id"
                                                    label="NAT Map Id">
                                                <template #append>
                                                    <v-btn @click="open_nat_map_box()">...</v-btn>
                                                </template>                          
                                            </v-text-field>
                                            <span class="required_err">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </v-col>
                                </v-row>  
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="nat_map_form__close">
                                Cancel</v-btn>
                            <v-btn color="blue darken-1" :disabled="invalid"
                                    text @click="nat_map_form__save">
                                Save</v-btn>
                        </v-card-actions>
                    </v-card>
                </ValidationObserver>
            </v-dialog>

            <v-dialog v-model="dialog" max-width="600px">
                <div>
                    <vif_box v-model="show_vif_form"
                        @canceled="on_vif_cancel" 
                        @selected="on_vif_select($event)">
                    </vif_box>
                    <nat_policy_box v-model="show_nat_policy_box"
                        @canceled="nat_policy_box_on_cancel" 
                        @selected="nat_policy_box_on_select($event)">
                    </nat_policy_box>
                </div>

                <template v-slot:activator="{ props }">
                    <v-btn @click="new_item(item)"
                        color="primary" dark class="mb-2"
                        v-bind="props">
                        Add interface
                    </v-btn>
                </template>

                <ValidationObserver ref="observer" v-slot="{ invalid }"><v-card>
                    <v-card-title>
                        <span class="headline">{{ edit_caption }}</span>
                    </v-card-title>

                    <v-card-text>
                        <v-container style="height: 520px; overflow-y: scroll;">
                            <v-row>

                        <v-col cols="12">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <v-text-field
                                    v-bind:readonly="edited_index != -1"
                                    v-model="edited_item.vif_name"
                                    label="VIF">
                                    <template v-if="edited_index == -1" #append>
                                        <v-btn @click="open_vif_form()">...</v-btn>
                                    </template>                          
                                </v-text-field>
                                <span class="required_err">{{ errors[0] }}</span>
                            </ValidationProvider> 

                            <div class="br_label" v-if="edited_index == -1">
                                NAT type
                                <treeselect
                                    v-model="edited_item.nat_type"
                                    :multiple="false" 
                                    :options="nat_types"/>
                            </div>
                            <v-text-field
                                v-if="edited_index != -1"
                                v-bind:readonly="true"
                                v-model="edited_item.nat_type"
                                label="NAT type">
                            </v-text-field>                            
                            
                            <div v-if="edited_item.nat_type == 'snat44' || edited_item.nat_type == 'det_snat44' ||
                                edited_item.nat_type == 'snat1to1'" class="br_section">
                                <v-toolbar flat>
                                    <v-toolbar-title>NAT maps</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-btn @click="nat_map_form__show()">Add</v-btn>
                                </v-toolbar>
                                <v-data-table
                                    v-bind:readonly="true"
                                    :headers="nat_maps_hdrs"
                                    :items="edited_item.nat_maps"
                                    :search="search"
                                    sort-by="state"
                                    hide-default-footer
                                    class="elevation-1">
                                    <template v-slot:item.actions="{ item }">
                                        <v-icon small @click="nat_maps_del(item)">
                                            mdi-delete
                                        </v-icon>
                                    </template>
                                    <template v-slot:no-data>
                                        No records
                                    </template>
                                </v-data-table>
                            </div>

                            <div v-if="edited_item.nat_type == 'nat_policy'" class="br_section">
                                <ValidationProvider rules="required|numeric" v-slot="{ errors }">
                                    <v-text-field
                                        v-bind:readonly="edited_index != -1"
                                        v-model="edited_item.nat_policy_id"
                                        label="NAT policy ID">
                                        <template v-if="edited_index == -1" #append>
                                            <v-btn @click="open_nat_policy_form()">...</v-btn>
                                        </template>                          
                                    </v-text-field>
                                    <span class="required_err">{{ errors[0] }}</span>
                                </ValidationProvider> 
                            </div>                            
                        </v-col>

                            </v-row>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn v-if="edited_index !== -1" color="blue darken-1"
                            text @click="close">Close</v-btn>
                        <v-btn v-if="edited_index === -1" color="blue darken-1"
                            text @click="close">Cancel</v-btn>
                        <v-btn v-if="edited_index === -1" color="blue darken-1" 
                            :disabled="invalid" text @click="save">Save</v-btn>
                    </v-card-actions>
                </v-card></ValidationObserver>
            </v-dialog>
        </v-toolbar>
    
        <v-toolbar flat>
            <v-text-field v-model="search"
                append-icon="mdi-magnify" label="Search" single-line hide-details
            ></v-text-field>
        </v-toolbar>
    </template>

    <template v-slot:item.actions="{ item }">
        <v-icon small class="me-2" @click="edit_item(item)">
            mdi-pencil
        </v-icon>
        <v-icon small @click="delete_item(item)">
            mdi-delete
        </v-icon>
    </template>

    <template v-slot:no-data>
    </template>

    </v-data-table>
</div>
</template>
  
<script>

import api_client from '../services/api.js';
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { ValidationProvider, extend } from 'vee-validate';
import { ValidationObserver } from 'vee-validate';
import { required, numeric } from 'vee-validate/dist/rules';
import vif_box from "../components/vif_box.vue";
import vif_ip_addr_box from "../components/vif_ip_addr_box.vue";
import det_nat_map_box from "../components/det_nat_map_box.vue";
import nat3_map_box from "../components/nat3_map_box.vue";
import nat11_map_box from "../components/nat11_map_box.vue";
import nat_policy_box from "../components/nat_policy_box.vue";
import ipv4_route_table_box from "../components/ipv4_route_table_box.vue";
import "../validation_rules.js";

export default {
name: "nat_interface",
components: { 
    Treeselect, ValidationProvider, ValidationObserver, vif_box, vif_ip_addr_box,
    ipv4_route_table_box, det_nat_map_box, nat3_map_box, nat11_map_box, nat_policy_box
},
data: () => ({
    deleted_ind: -1,

    nat_map_id: '',
    new_nat_map_dialog: false,

    show_det_nat_map_box: false,
    show_snat_map_box: false,
    show_nat1to1_map_box: false,
    show_nat_policy_box: false,

    show_vif_form: false,

    edit_caption: '',
    search: '',
    dialog: false,

    nat_maps_hdrs: [
        { text: 'NAT map id', value: 'map_id', align: 'start' },
        { text: 'Actions', value: 'actions', sortable: false },
    ],

    headers: [
        { text: 'VIF name', value: 'vif_name', align: 'start' },
        { text: 'Port', value: 'port' },
        { text: 'SVID', value: 'svid' },
        { text: 'CVID', value: 'cvid' },
        { text: 'NAT type', value: 'nat_type' },
        { text: 'NAT details', value: 'nat_details' },
        { text: 'Actions', value: 'actions', sortable: false },
    ],

    nat_types: [
        {
            id: 'det_snat44',
            label: 'Deterministic SNAT44',
        },
        {
            id: 'snat44',
            label: 'SNAT44',
        },
        {
            id: 'snat1to1',
            label: 'SNAT44 1:1',
        },
        {
            id: 'nat_policy',
            label: 'NAT Policy',
        },
    ],

    items: [],
    edited_index: -1,
    edited_item: {
    },
    default_item: {
        vif_name: '',
        vif_type: '',
        nat_maps: [],
        nat_policy_id: '',
    },

    save_steps: [],
    save_step_ind: 0,
}),

watch: {
},

created() {
    this.initialize()
},

methods: {
    calculate_fields(item) {
        if (item.nat_type == "det_snat44" || 
            item.nat_type == "snat44" ||
            item.nat_type == "snat1to1") {

            item["nat_details"] = "maps: ";
            item["nat_maps"] = [];

            let comma = 0;
            item.maps.forEach(map_id => {
                if (comma == 1) {
                    item["nat_details"] += ', ';
                }
                item.nat_details += map_id;
                item.nat_maps.push({ 'map_id': map_id });
                comma = 1;
            });
        }
        else if (item.nat_type == "nat_policy") {
            item["nat_details"] = "nat_policy_id: " + item.nat_policy_id;
        }
        else {
            item["nat_details"] = "";
        }
    },

    initialize() {
        return new Promise((resolve, reject) => {
            api_client.run_get_query('/nat/show_interfaces')
            .then(response => {
                this.items = response.data;
                this.items.forEach(i => {
                    this.calculate_fields(i);
                });
                resolve(response);
            })
            .catch(error => {
                console.log(error);
            });
        });
    },

    edit_item(item) {
        this.edited_index = this.items.indexOf(item);
        this.edited_item = Object.assign({}, item);
        this.edit_caption = 'NAT interface ' + this.edited_item.vif_name;
        this.dialog = true;
    },

    new_item() {
        this.edit_caption = 'Add a new NAT interface';
        requestAnimationFrame(() => {
            this.$refs.observer.reset();
        });          
        this.edited_index = -1;
        this.edited_item = Object.assign({}, this.default_item);
        this.edited_item.nat_maps = [];
        this.dialog = true;
    },

    on_dbl_click(event, data) {
        this.edit_item(data.item);
    },

    close() {
        this.dialog = false;
        this.$nextTick(() => {
            this.edited_index = -1;
        });
        this.initialize();
    },

    delete_item(item) {
        this.edited_index = this.items.indexOf(item);
        this.edited_item = Object.assign({}, item);
        this.$confirm("Are you sure you want to delete NAT interface " + item.vif_name + " ?")
        .then(() => {
            this.delete_item_confirm()
        });
    },

    delete_item_confirm() {
        let url;
        let data;

        if (this.edited_item.nat_type == 'nat_policy') {
            url = "/nat/nat_policy/del_vif";
            data = {
                vif_name: this.edited_item.vif_name,
                nat_policy_id: this.edited_item.nat_policy_id,
            };
        }
        else {
            url = "/nat/" + this.edited_item.nat_type  + "/vif_disable";
            data = {
                vif_name: this.edited_item.vif_name,
            };
        }

        api_client.run_post_query(url, data)
        .then(response => {
            if (response.data.hasOwnProperty("err_msg")) {
                this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
            }
            else {
                this.items.splice(this.edited_index, 1);
            }
        })
        .catch(error => {
            console.log(error);
            this.$fire({title: "Command failed", text: error, type: "warning"});
        });
    },

    on_save_completed() {
        this.close();
    },

    save_seq() {
        let save_step = this.save_steps[this.save_step_ind++];

        if (save_step.url != '') {
            api_client.run_post_query(save_step.url, save_step.data)
            .then(response => {
                if (response.data.hasOwnProperty("err_msg")) {
                    this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                }
                else {
                    if (this.save_step_ind == this.save_steps.length) {
                        this.on_save_completed();
                    }
                    else {
                        this.save_seq();
                    }
                }
            })
            .catch(error => {
                console.log(error);
                this.$fire({title: "Command failed", text: error, type: "warning"});
            });
        }
        else {
            if (this.save_step_ind == this.save_steps.length) {
                this.on_save_completed();
            }
            else {
                this.save_seq(); 
            }
        }
    },

    save_new_map() {
        let i = 0;
        let add_map_url = "/nat/" + this.edited_item.nat_type + "/vif_add_map";
        let vif_enable_url = "/nat/" + this.edited_item.nat_type + "/vif_enable";

        /* enable nat */
        this.save_steps[i++] = {
            url: vif_enable_url,
            data: {
                vif_name: this.edited_item.vif_name
            }
        };

        /* add maps */
        this.edited_item.nat_maps.forEach(item => {
            this.save_steps[i++] = {
                url: add_map_url,
                data: {
                    vif_name: this.edited_item.vif_name,
                    map_id: item.map_id
                }
            };
        });

        this.save_step_ind = 0;
        this.save_seq();
    },

    save_new_nat_policy() {
        let data = {
            vif_name: this.edited_item.vif_name,
            nat_policy_id: this.edited_item.nat_policy_id,
        };

        api_client.run_post_query('/nat/nat_policy/add_vif', data)
        .then(response => {
            if (response.data.hasOwnProperty("err_msg")) {
                this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
            }
            else {
                /* success */
                this.initialize();
                this.close();
            }
        })
        .catch(error => {
            console.log(error);
            this.$fire({title: "Command failed", text: error, type: "warning"});
        });        
    },

    save() {
        if (this.edited_index === -1) {
            if (this.edited_item.nat_type == 'nat_policy') {
                this.save_new_nat_policy();
            }
            else {
                this.save_new_map();
            }
        }
    },

    on_vif_cancel() {
        this.show_vif_form = false;
    },

    on_vif_select(data) {
        this.edited_item.vif_name = data.name;
        this.show_vif_form = false;
    },

    open_vif_form() {
        this.show_vif_form = true;
    },

    nat_map_form__show() {
        // close all nat map boxes
        this.nat_map_box_on_cancel();

        this.nat_map_id = '';
        requestAnimationFrame(() => {
            this.$refs.new_nat_map_observer.reset();
        });          
        this.new_nat_map_dialog = true;
    },

    nat_map_form__close() {
        this.new_nat_map_dialog = false;
    },

    nat_map_form__save() {
        this.edited_item.nat_maps.push({ 'map_id': this.nat_map_id });

        if (this.edited_index === -1) {
            this.nat_map_form__close();
        }
        else {
            let add_map_url = "/nat/" + this.edited_item.nat_type + "/vif_add_map";
            api_client.run_post_query(add_map_url, {
                vif_name: this.edited_item.vif_name,
                map_id: this.nat_map_id
            })
            .then(response => {
                if (response.data.hasOwnProperty("err_msg")) {
                    this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                }
                else {
                    this.nat_map_form__close();
                }
            })
            .catch(error => {
                console.log(error);
                this.$fire({title: "Command failed", text: error, type: "warning"});
            });
        }
    },

    open_nat_map_box() {
        if (this.edited_item.nat_type == 'det_snat44') {
            this.show_det_nat_map_box = true;
        }
        else if (this.edited_item.nat_type == 'snat44') {
            this.show_snat_map_box = true;
        }
        else if (this.edited_item.nat_type == 'snat1to1') {
            this.show_nat1to1_map_box = true;
        }
        else if (this.edited_item.nat_type == 'nat_policy') {
            this.show_nat_policy_box = true;
        }
    },

    nat_map_box_on_cancel() {
        this.show_det_nat_map_box = false;
        this.show_snat_map_box = false;
        this.show_nat1to1_map_box = false;
        this.show_nat_policy_box = false;
    },

    nat_map_box_on_select(map_id) {
        this.nat_map_id = map_id;
        this.nat_map_box_on_cancel();
    },

    nat_maps_del(item) {
        this.deleted_ind = this.edited_item.nat_maps.indexOf(item);
        this.$confirm("Are you sure you want delete map " + item.map_id + " from NAT interface " + 
            this.edited_item.vif_name + " ?")
        .then(() => {
            this.nat_maps_del_confirm();
        });
    },

    nat_maps_del_confirm() {
        let map_id = this.edited_item.nat_maps[this.deleted_ind].map_id;
        this.edited_item.nat_maps.splice(this.deleted_ind, 1);
        if (this.edited_index != -1) {
            let url = "/nat/" + this.edited_item.nat_type + "/vif_del_map";
            api_client.run_post_query(url, {
                vif_name: this.edited_item.vif_name,
                map_id: map_id
            })
            .then(response => {
                if (response.data.hasOwnProperty("err_msg")) {
                    this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                }
                else {
                    this.nat_map_form__close();
                }
            })
            .catch(error => {
                console.log(error);
                this.$fire({title: "Command failed", text: error, type: "warning"});
            });                        
        }
    },

    open_nat_policy_form() {
        this.show_nat_policy_box = true;
    },
    
    nat_policy_box_on_cancel() {
        this.show_nat_policy_box = false;
    },

    nat_policy_box_on_select(map_id) {
        this.edited_item.nat_policy_id = map_id;
        this.show_nat_policy_box = false;
    },
}

};
</script>
